import React from "react"
import AutomationIdCheckForm, { AutomationIdCheckOTPForm } from "./AutomationIdCheckForm"
import AutomationDontSubmitSection from "./AutomationDontSubmitSection"
import AutomationEmailSection from "./AutomationEmailSection"
import { Button } from "@mui/material"
import AutomationRefCodesSection from "./AutomationRefCodesSection"


export default function AutomationConfirmFormSection ({
    automationOption,
    automationData,
    hidden = true,
    onCancel = () => {},
    onSubmit = (values) => {}
}) {

    if (hidden) return <></>

    if (automationOption.navigation_style.includes("sms")) {
        return (
            <AutomationDontSubmitSection 
                onSubmit={async (values) => await onSubmit(values)} 
                onCancel={onCancel} 
                automationOption={automationOption} />
        )
    }

    if (["home_office_classic"].includes(automationOption.navigation_style)) {
        return (
            <AutomationRefCodesSection
                onSubmit={async (values) => await onSubmit(values)} 
                onCancel={onCancel} 
                automationOption={automationOption} 
                automationData={automationData} />
        )
    }

    if (automationOption.navigation_style === "home_office_dashboard") {
        return (
            <HomeOfficeDashboardSection 
                onSubmit={async (values) => await onSubmit(values)} 
                onCancel={onCancel} 
                automationOption={automationOption} 
                automationData={automationData} />
        )
    }

    // Fall back to just a submit button, if navigation style is not recognised.
    return (
        <Button 
            className="btn btn-sm" 
            variant="contained" 
            color="success" 
            onClick={async () => await onSubmit({})}>
            Start {automationOption.navigation_style} automation
        </Button>
    )
}


function HomeOfficeDashboardSection ({
    automationOption,
    automationData,
    onCancel = () => {},
    onSubmit = async (values) => {}
}) {
    
    const [idCheckValues, setIdCheckValues] = React.useState(null)

    return (
        <>
            <AutomationIdCheckForm
                hidden={idCheckValues}
                automationData={automationData}
                onCancel={() => onCancel()}
                onSubmit={(values) => setIdCheckValues(values)} />

            <AutomationRefCodesSection 
                includeSubjectEmail={false}
                hidden={!idCheckValues}
                onSubmit={async (values) => await onSubmit({...automationData, ...idCheckValues, ...values})} 
                onCancel={() => setIdCheckValues(null)} 
                automationOption={automationOption} 
                automationData={automationData} />
        </>
    )
}